import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "q-row autocomplete-popup__container" }
const _hoisted_2 = {
  key: 1,
  class: "autocomplete-popup__no-results"
}

import ProductsContainer from '@/components/AutocompletePopup/Products/ProductsContainer.vue'

import SuggestionsContainer from '@/components/AutocompletePopup/ShowResults/Suggestions/SuggestionsContainer.vue';
import MoreResultsButton from '@/components/AutocompletePopup/ShowResults/Results/MoreResultsButton.vue';

import {ref, inject, computed} from 'vue';

import {SmartSearchConfigInterface, SmartSearchTranslationsInterface} from '@/core/types'
import {storeToRefs} from "pinia";
import {useSearchQueryStore} from "@/store/SearchQueryStore";
import {usePopupStore} from "@/store/AutocompletePopup/PopupStore";
import {useMobileViewStore} from "@/store/MobileViewStore";



export default /*#__PURE__*/_defineComponent({
  __name: 'AutocompleteContainer',
  setup(__props) {

const SmartSearchConfig: SmartSearchConfigInterface = inject('SmartSearchConfig').value;
const suggestionsEnabled = ref(SmartSearchConfig.autocomplete.suggestions.enabled)
const bestsellerEnabled = SmartSearchConfig.autocomplete.bestseller.enabled

const searchQueryStore = useSearchQueryStore()
const mobileViewStore = useMobileViewStore()
const {searchQuery} = storeToRefs(searchQueryStore)
const {isMobileView} = storeToRefs(mobileViewStore)
const popupStore = usePopupStore()
const {
  getAutocompleteResults,
  hasNoResults,
  getAutocompleteResultsWithoutFirst,
  getBestseller,
  canShowPromotedSection
} = storeToRefs(popupStore)
const results = computed(() => {
  if (bestsellerEnabled && canShowPromotedSection.value) {
    return getAutocompleteResultsWithoutFirst.value
  }
  return getAutocompleteResults.value
})
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SmartSearchTranslations = inject<SmartSearchTranslationsInterface>('SmartSearchTranslations')!

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (suggestionsEnabled.value)
      ? (_openBlock(), _createBlock(SuggestionsContainer, { key: 0 }))
      : _createCommentVNode("", true),
    (_unref(hasNoResults))
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
          _createTextVNode(_toDisplayString(_unref(SmartSearchTranslations).autocomplete.noResults) + ": ", 1),
          _createElementVNode("b", null, _toDisplayString(_unref(searchQuery)), 1)
        ]))
      : (_openBlock(), _createElementBlock("div", {
          key: 2,
          id: "autocompleteResults",
          class: _normalizeClass(["autocomplete-popup__results-container", { 'q-col-12 q-col-md-9 q-pt-1': suggestionsEnabled.value,
      'q-col-md-12 q-pt-1': !suggestionsEnabled.value}])
        }, [
          _createVNode(ProductsContainer, {
            "products-header": _unref(SmartSearchTranslations).autocomplete.resultsHeader,
            "section-enabled": true,
            "promoted-product-enabled": _unref(bestsellerEnabled),
            "promoted-product": _unref(getBestseller),
            "promoted-product-header": _unref(SmartSearchTranslations).autocomplete.bestsellerHeader,
            "products-list": results.value,
            "can-show-promoted-section": _unref(canShowPromotedSection)
          }, null, 8, ["products-header", "promoted-product-enabled", "promoted-product", "promoted-product-header", "products-list", "can-show-promoted-section"]),
          _createVNode(MoreResultsButton)
        ], 2))
  ]))
}
}

})